import React from "react";

import styles from "./MedicalHistory.module.scss";

export const StyledMedicalSection: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.styledMedicalSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const StyledMedicalSectionHeader: React.FC<
  React.HTMLAttributes<HTMLHeadingElement>
> = ({ children, className, ...rest }) => (
  <h3
    className={`${styles.styledMedicalSectionHeader} ${className ?? ""}`}
    {...rest}>
    {children}
  </h3>
);

export const StyledMedicalContentLabel: React.FC<
  React.HTMLAttributes<HTMLParagraphElement>
> = ({ children, className, ...rest }) => (
  <p
    className={`${styles.styledMedicalContentLabel} ${className ?? ""}`}
    {...rest}>
    {children}
  </p>
);

export const StyledMedicalContent: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.styledMedicalContent} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
